import {styled} from "@mui/material/styles";
import MuiIconButton from "@mui/material/IconButton";

const StyledCloseButton = styled(MuiIconButton)({
  position: 'absolute',
  top: 0,
  right: 0
})

export { StyledCloseButton }
